import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the lightweight DICOM-caching service worker. Safe in dev:
// it only intercepts /api/dicom/image/* and is a no-op otherwise.
registerServiceWorker();
